<template>
  <div class="contents">
      <img :style="{width:imgwidth+'px','margin-top':margintop+'px','margin-bottom':marginbottom+'px'}" :src="src" >
  </div>
</template>

<script>
export default {
    /*props:["src",'imgwidth']*/
    props: {
        src:{
            type: String,
            default: ''
        },
        imgwidth:{
            type: Number,
            default: 525
        },
        margintop:{
            type: Number,
            default: 106
        },
        marginbottom:{
            type: Number,
            default: 66
        }
    }
}
</script>

<style scoped>
    .contents{
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// src/components/index/GoodsClassTitle.vue